export var BaseEcomSdkEnumsObj = {
    PAYAIR_ECOM_WRAPPER_SDK: "PAYAIR_ECOM_WRAPPER_SDK",
    PAYAIR_APPLE_PAY_SDK: "PAYAIR_APPLE_PAY_SDK",
    PAYAIR_GOOGLE_PAY_SDK: "PAYAIR_GOOGLE_PAY_SDK",
    PAYAIR_SRCI_SDK: "PAYAIR_SRCI_SDK",
    PAYAIR_SAMSUNG_PAY_SDK: "PAYAIR_SAMSUNG_PAY_SDK",
};
